import { useEffect, useLayoutEffect, useState } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Button, Input } from '$uikit';
import { useTranslator } from '$hooks';
import './Prompt.sass';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';

export const Prompt = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [{ title, description, placeholder }, setTextData] = useState<{
    title?: string;
    description: string;
    placeholder?: string;
  }>({
    title: t('prompt_default_title'),
    description: '',
  });
  const [isVisible, setIsVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useLayoutEffect(() => {
    addEventListener('showPrompt', handleShowPrompt);

    return () => {
      removeEventListener('showPrompt', handleShowPrompt);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) {
      setInputValue('');
    }
  }, [isVisible]);

  const handleShowPrompt = (e) => {
    const payload = e.detail;

    if (typeof payload === 'string') {
      setTextData({ description: payload });
    } else {
      setTextData(payload);
    }

    setIsVisible(true);

    dispatch(toastActions.hideToast());
  };

  const handleClose = () => {
    dispatchEvent(new CustomEvent('rejectPrompt'));
    setIsVisible(false);
  };

  const handleSubmit = () => {
    dispatchEvent(
      new CustomEvent('submitPrompt', {
        detail: inputValue,
      }),
    );
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <BottomSheet title={title} onClose={handleClose} className="Prompt">
      <div className="Prompt__description">{description}</div>
      <Input
        placeholder={placeholder}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        value={inputValue}
        autoFocus
      />
      <Button onClick={handleSubmit} className="Prompt__button">
        {t('prompt_default_button')}
      </Button>
    </BottomSheet>
  );
};
